export type EditMode = 'full' | 'partial' | 'link';

export function resolveEditMode(linkOnlyEdit: boolean, fullEditStatus: boolean): EditMode {
    if (linkOnlyEdit) {
        return 'link';
    }
    if (fullEditStatus) {
        return 'full';
    }
    return 'partial';
}
